import { useRecoilState } from "recoil";
import { userAtom } from "../../atoms/user.atom";
import { useRouter } from "next/router";
import { useEffect } from "react";
import {
  AccessTokenStore,
  REFRESH_TOKEN_KEY,
  refreshAccessToken,
} from "@monorepo/components";
import { ProtectedUserWithRole, UserRole } from "@monorepo/api-types";
import { setGtmVariable } from "apps/dashboard-client/utils/googleTagManagerUtils";

const useAuth = (roles?: UserRole[]) => {
  const [userState, setUserState] = useRecoilState(userAtom);

  const router = useRouter();

  useEffect(() => {
    if (!userState) {
      attemptLogin();
    } else if (
      roles &&
      userState.user_roles.every(
        (role) =>
          role.name !== UserRole.ADMIN && !roles.includes(role.name as UserRole)
      )
    ) {
      router.push("/");
    }
  }, [userState]);

  useEffect(() => {
    if (userState?.institution?.disabled && router.pathname !== "/disabled") {
      router.push("/disabled");
    }
  }, [userState, router.pathname]);

  async function attemptLogin() {
    try {
      const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);
      if (!refreshToken) {
        setUserState(null);
        return router.push("/login");
      }
      const { AccessToken, user } = await refreshAccessToken(refreshToken);
      AccessTokenStore.set(AccessToken as string);
      setUserState(user as ProtectedUserWithRole);
      if (user) {
        setGtmVariable({ user });
      }
    } catch (e) {
      return router.push("/login");
    }
  }
};

export default useAuth;
